export default __webpack_public_path__ + "static/summit_stars_4_8-a26d3d892b658527caccce8c41087955.svg";